import { render } from "./BaseSlideOver.vue?vue&type=template&id=6e3cb1a0"
import script from "./BaseSlideOver.vue?vue&type=script&lang=js"
export * from "./BaseSlideOver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__